"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_interfaces_1 = require("dyna-interfaces");
var DynaNodeMessage_1 = require("../DynaNodeMessage/DynaNodeMessage");
var DynaNodeService_1 = require("../DynaNodeService/DynaNodeService");
var interfacesMasterWorker_1 = require("../DynaNodeMasterService/interfacesMasterWorker");
var consoleStringify_1 = require("../utils/consoleStringify");
var DynaNodeWorkerService = /** @class */ (function () {
    function DynaNodeWorkerService(_config) {
        var _this = this;
        this._config = _config;
        this._handleServiceStart = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._registerWorker()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this._handleServiceStop = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._deactivateHeartbeat();
                return [2 /*return*/];
            });
        }); };
        this.sendHeartBeat = function () {
            if (!_this._service.ready)
                return;
            _this._service.send({
                to: _this._config.masterDynaNodeAddress,
                command: interfacesMasterWorker_1.COMMAND_DynaNodeMasterServiceMessageHeartbeat,
                data: {
                    availabilityIndex: _this.getAvailabilityIndex(),
                },
            })
                .catch(function (error) {
                console.error("DynaNodeWorkerService [" + _this._service.friendlyName + "]: cannot send heartbeat to master (this might be temporary)", consoleStringify_1.consoleStringify(error));
            });
        };
        this.addCommand = function (commandName, commandConfig) {
            return _this._service.addCommand(commandName, commandConfig);
        };
        this._service = new DynaNodeService_1.DynaNodeService({
            compressMessages: this._config.compressMessages,
            disk: this._config.disk,
            parallelRequests: 1,
            serviceRegistration: undefined,
            prefixAddress: (this._config.prefixAddress || 'general') + '-worker',
            headers: this._config.headers,
            publicCommands: new Array().concat(this._config.publicCommands, interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServicePing, interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServiceWorkerWrappedMessage, interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServiceYouAreDead),
            retryConnectionConfig: this._config.retryConnectionConfig,
            defaultsServiceMessagePriorityValue: this._config.defaultsServiceMessagePriorityValue,
            defaultExecutionTimeout: this._config.defaultExecutionTimeout,
            onStart: this._handleServiceStart,
            onStop: this._handleServiceStop,
            onBeforeAnyCommand: this._config.onBeforeAnyCommand,
            onCommand: this._internalCommands,
            onClientConnectionLost: function () { return undefined; },
            onServiceRegistrationFail: function (error) { return console.error("DynaNodeWorkerService [" + _this._service.friendlyName + "]: cannot register to dyna node server", consoleStringify_1.consoleStringify({
                config: _this._config,
                error: error,
            })); },
            onMessageQueueError: function (error) { return console.error("DynaNodeWorkerService [" + _this._service.friendlyName + "]: message queue error (h/w, disk?)", consoleStringify_1.consoleStringify({
                config: _this._config,
                error: error,
            })); },
        });
    }
    DynaNodeWorkerService.prototype.start = function () {
        return this._service.start();
    };
    DynaNodeWorkerService.prototype.stop = function (waitForPendingMessages) {
        if (waitForPendingMessages === void 0) { waitForPendingMessages = true; }
        return this._service.stop(waitForPendingMessages);
    };
    DynaNodeWorkerService.prototype._registerWorker = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.getAvailabilityIndex(); })
            .then(function (availabilityIndex) {
            return _this._service.sendReceive({
                to: _this._config.masterDynaNodeAddress,
                command: interfacesMasterWorker_1.COMMAND_DynaNodeMasterServiceMessageRegisterWorker,
                retry: true,
                retryConfig: {
                    maxRetries: null,
                    retryTimeoutBaseMs: 3000,
                    increasePercentFrom: 10,
                    increasePercentTo: 20,
                    retryTimeoutMaxMs: 6000,
                },
                data: {
                    affiliateAccount: {
                        username: _this._config.affiliateUsername,
                        password: _this._config.affiliatePassword,
                    },
                    availabilityIndex: availabilityIndex,
                    publicCommands: _this._config.publicCommands,
                },
            });
        })
            .then(function (message) {
            switch (message.command) {
                case "deal":
                    _this._activateHeartbeat(message.data.heartbeatInterval);
                    return Promise.resolve();
                case "error":
                    console.error("DynaNodeWorkerService [" + _this._service.friendlyName + "]: Cannot register worker by error", consoleStringify_1.consoleStringify(message.viewSecure));
                    return Promise.reject({
                        code: 1810202011,
                        section: "DynaNodeWorker/_registerWorker",
                        errorType: dyna_interfaces_1.EErrorType.APP,
                        message: "Register worker, server responded error",
                        error: message.data,
                    });
                default:
                    console.error("DynaNodeWorkerService [" + _this._service.friendlyName + "]: Cannot register worker, (unknown reply)", consoleStringify_1.consoleStringify(message.viewSecure));
                    return Promise.reject({
                        code: 1810202012,
                        section: "DynaNodeWorker/_registerWorker",
                        errorType: dyna_interfaces_1.EErrorType.APP,
                        message: "Register worker, server responded with unknown command",
                        data: { message: message },
                    });
            }
        });
    };
    DynaNodeWorkerService.prototype._activateHeartbeat = function (heartbeatInterval) {
        this._deactivateHeartbeat(); // ensure to stop it
        this.sendHeartBeat(); // send the initial asap
        this._heartbeatIntervalHandler = setInterval(this.sendHeartBeat, heartbeatInterval);
    };
    DynaNodeWorkerService.prototype._deactivateHeartbeat = function () {
        if (!this._heartbeatIntervalHandler)
            return;
        clearInterval(this._heartbeatIntervalHandler);
        this._heartbeatIntervalHandler = null;
    };
    Object.defineProperty(DynaNodeWorkerService.prototype, "active", {
        get: function () {
            return this._service.active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeWorkerService.prototype, "ready", {
        get: function () {
            return this._service.ready;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeWorkerService.prototype, "parallelRequests", {
        get: function () {
            return this._service.unprocessedMessages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeWorkerService.prototype, "friendlyName", {
        get: function () {
            return this._service.friendlyName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeWorkerService.prototype, "stats", {
        get: function () {
            return this._service.stats;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeWorkerService.prototype, "serviceAddress", {
        get: function () {
            return this._service.serviceAddress;
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeWorkerService.prototype.sendToMe = function (args) {
        this._service.sendToMe(args);
    };
    DynaNodeWorkerService.prototype.sendToMeMessage = function (message) {
        this._service.sendToMeMessage(message);
    };
    DynaNodeWorkerService.prototype.send = function (config) {
        return this._service.send(config);
    };
    DynaNodeWorkerService.prototype.sendReceive = function (config) {
        return this._service.sendReceive(config);
    };
    DynaNodeWorkerService.prototype.reply = function (sourceMessage, config) {
        return this._service.reply(sourceMessage, config);
    };
    DynaNodeWorkerService.prototype.fetch = function (config) {
        return this._service.fetch(config);
    };
    DynaNodeWorkerService.prototype.getAvailabilityIndex = function () {
        return ((this._config.getAvailabilityIndex && this._config.getAvailabilityIndex() || 0) +
            this._service.getAvailabilityIndex());
    };
    Object.defineProperty(DynaNodeWorkerService.prototype, "_internalCommands", {
        get: function () {
            var _a;
            var _this = this;
            return _a = {},
                _a[interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServicePing] = {
                    execute: function (_a) {
                        var reply = _a.reply, next = _a.next;
                        reply({
                            args: { serviceMessagePriorityValue: 0 },
                            command: 'pong',
                        }).catch(function () { return undefined; });
                        next();
                    },
                },
                _a[interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServiceWorkerWrappedMessage] = {
                    executionTimeout: 1000,
                    execute: function (_a) {
                        var message = _a.message, reply = _a.reply, next = _a.next;
                        if (message.from !== _this._config.masterDynaNodeAddress) {
                            var errorMessage = "DynaNodeWorkerService [" + _this._service.friendlyName + "]: received message \"" + interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServiceWorkerWrappedMessage + "\" like command, from an unauthorized sender, this would be a network attack. Message is discarded.";
                            var errorData = consoleStringify_1.consoleStringify(message.viewSecure);
                            console.warn(errorMessage, errorData);
                            reply({
                                command: 'error/dyna-node/403.304',
                                data: {
                                    code: 403.404,
                                    message: errorMessage,
                                    data: errorData,
                                },
                            })
                                .catch(function () { return undefined; });
                            next();
                            return;
                        }
                        if (message.data &&
                            message.data.master &&
                            message.data.master.originalData) {
                            var wrappedMessage = new DynaNodeMessage_1.DynaNodeMessage();
                            wrappedMessage.id = message.data.master.originalData.id;
                            wrappedMessage.from = message.data.master.originalData.from;
                            wrappedMessage.to = message.data.master.originalData.to;
                            wrappedMessage.headers = message.data.master.originalData.headers;
                            wrappedMessage.args = message.data.master.originalData.args;
                            wrappedMessage.command = message.data.master.originalData.command;
                            wrappedMessage.data = message.data.master.originalData.data;
                            wrappedMessage.binaryData = message.binaryData;
                            wrappedMessage.dynaNodeInfo = __assign(__assign({}, message.data.master.originalData.dynaNodeInfo), { isForwardedFromMaster: true });
                            wrappedMessage.traces = message.data.master.originalData.traces;
                            wrappedMessage._addTrace('DynaNode/WorkerService/WORKER_RECEIVING_FROM_MASTER', "DynaNode: DynaNodeWorker, incoming wrapped message", _this._traceData);
                            _this.sendToMeMessage(wrappedMessage);
                            message._addTrace('DynaNode/WorkerService/WORKER_RECEIVED_FROM_MASTER', 'DynaNode: DynaNodeWorker received that message and pushed to its queue', _this._traceData);
                            reply({
                                command: 'ok/4200',
                                headers: {
                                    dg: wrappedMessage.headers.dg,
                                },
                                args: {
                                    debug: '_debug_ret231356134134',
                                    serviceMessagePriorityValue: 0,
                                },
                                data: _this.stats,
                            }).catch(function () { return undefined; });
                        }
                        next();
                    },
                },
                _a[interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServiceYouAreDead] = {
                    executionTimeout: 1000,
                    execute: function (_a) {
                        var message = _a.message, reply = _a.reply, next = _a.next;
                        if (message.from !== _this._config.masterDynaNodeAddress) {
                            console.warn("DynaNodeWorkerService [" + _this._service.friendlyName + "]: 202002120830 received command " + interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServiceYouAreDead + " not from master. Someone is trying to hack the worker.", consoleStringify_1.consoleStringify(message.viewSecure));
                            next();
                            reply({ command: 'ok' }).catch(function () { return undefined; });
                            return;
                        }
                        console.warn("DynaNodeWorkerService [" + _this._service.friendlyName + "]: 202002111240 Master unregistered the worker due to general late responses. Worker will re-register to the Master.");
                        next();
                        reply({ command: 'ok' }).catch(function () { return undefined; });
                        _this._deactivateHeartbeat();
                        _this._registerWorker()
                            .catch(function (error) {
                            console.error("DynaNodeWorkerService [" + _this._service.friendlyName + "]: 202002130603 Worker cannot re-register with master, after 202002120830", consoleStringify_1.consoleStringify(error));
                        });
                    },
                },
                _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeWorkerService.prototype, "_traceData", {
        get: function () {
            return { service: this.friendlyName };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeWorkerService.prototype, "_debug_service", {
        get: function () {
            return this._service;
        },
        enumerable: true,
        configurable: true
    });
    return DynaNodeWorkerService;
}());
exports.DynaNodeWorkerService = DynaNodeWorkerService;
//# sourceMappingURL=DynaNodeWorkerService.js.map